import { Col, Divider, Space, Button, Dropdown, Menu, message, Row } from 'antd';
import React, { useState, useCallback, useMemo } from 'react';
import Card from './Card';
import styled from 'styled-components';
import { Copy, Invisible, Visible, Ellipsis, Edit, Delete } from 'assets/icons';

const DeviceCard = ({ device, handleEdit, handleDelete }) => {
	const [isTokenVisible, setTokenVisible] = useState(false);

	const toggleVisible = useCallback(() => {
		setTokenVisible((prev) => !prev);
	}, []);

	const menu = useMemo(
		() => (
			<StyledMenu>
				<Menu.Item icon={<Edit />} onClick={handleEdit}>
					Edit
				</Menu.Item>
				<Menu.Divider />
				<Menu.Item icon={<Delete />} danger onClick={handleDelete}>
					Delete
				</Menu.Item>
			</StyledMenu>
		),
		[handleEdit, handleDelete]
	);

	const detailItems = [
		{ label: 'Edge Recipe', value: device.recipename },
		{ label: 'Hardware Name', value: device.hardware_name },
		{ label: 'MAC Address', value: device.mac_address },
		{ label: 'OS', value: device.os },
	];

	return (
		<StyledCard>
			<DropdownContainer>
				<Dropdown overlay={menu} placement="bottomRight">
					<Button type="link" icon={<Ellipsis style={{ color: '#808080' }} />} />
				</Dropdown>
			</DropdownContainer>

			<DeviceName>{device.devicename}</DeviceName>
			<DeviceId>{device.deviceid}</DeviceId>

			<InfoGrid gutter={[16, 8]}>
				{detailItems.map((item) => (
					<Col xs={12} sm={24} md={24} lg={12} key={item.label}>
						<Label>{item.label} :</Label>
						<Value>{item.value || 'None'}</Value>
					</Col>
				))}
			</InfoGrid>

			<StyledDivider />

			<FlexContainer>
				<Col flex="none" style={{ padding: 0 }}>
					<Label>Device Token : </Label>
				</Col>
				<DeviceTokenContainer>
					<FlexContainer>
						<Token>
							{isTokenVisible ? device.devicetoken : 'X'.repeat(device.devicetoken?.length || 0)}
						</Token>
						<Col flex="none" style={{ padding: 0, fontSize: '14px' }}>
							<Space size={4}>
								<IconBtn icon={isTokenVisible ? <Visible /> : <Invisible />} onClick={toggleVisible} />
								<IconBtn
									icon={<Copy />}
									onClick={() => {
										navigator.clipboard.writeText(device.devicetoken);
										message.info('Copied Device Token to Clipboard');
									}}
								/>
							</Space>
						</Col>
					</FlexContainer>
				</DeviceTokenContainer>
			</FlexContainer>
		</StyledCard>
	);
};

export default React.memo(DeviceCard);

const StyledCard = styled(Card)`
	position: relative;
`;

const DropdownContainer = styled.div`
	position: absolute;
	top: 5px;
	right: 5px;
`;

const DeviceName = styled.div`
	font-size: 16px;
	font-weight: 500;
	color: #333;
`;

const DeviceId = styled(DeviceName)`
	font-size: 14px;
	color: #4d4d4d;
	margin-bottom: 15px;
`;

const InfoGrid = styled(Row)`
	margin-bottom: 10px;
`;

const Label = styled.span`
	font-size: 12px;
	color: #808080;
	margin-right: 8px;
`;

const Value = styled.span`
	font-size: 12px;
	color: #4d4d4d;
	word-break: break-all;
`;

const StyledDivider = styled(Divider)`
	margin: 10px 0;
`;

const FlexContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const DeviceTokenContainer = styled(Col).attrs({
	flex: 'auto',
	size: 4,
})`
	background: #f7f7f7;
	padding: 2px 5px;
	border-radius: 4px;
	margin-left: 4px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const Token = styled(Col).attrs({
	flex: 'auto',
})`
	color: #808080;
	padding: 0 !important;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const IconBtn = styled(Button).attrs({
	type: 'link',
})`
	width: 20px !important;
	padding: 0;
	color: #808080 !important;
`;

const StyledMenu = styled(Menu)`
	.ant-dropdown-menu-item,
	.ant-dropdown-menu-submenu-title {
		font-size: 14px;
		font-weight: normal;
		line-height: 1.5;
		letter-spacing: normal;
		color: #4d4d4d;
		padding-left: 20px;
	}

	min-width: 180px;
	padding: 8px 0;
	border-radius: 5px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
	background-color: #ffffff;

	.ant-dropdown-menu-item-divider,
	.ant-dropdown-menu-submenu-title-divider {
		background-color: rgba(207, 218, 230, 0.5);
	}

	.ant-dropdown-menu-item:hover,
	.ant-dropdown-menu-submenu-title:hover {
		background-color: #fff8e8;
	}

	.ant-dropdown-menu-item.ant-dropdown-menu-item-danger {
		:hover {
			color: #f64e60;
			background-color: rgba(246, 78, 96, 0.14);
			font-weight: normal;
		}
	}
`;
